import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface PublicationActionModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (reason: string) => void
  title: string
  action: 'relevant' | 'irrelevant'
  loading?: boolean
}

export function PublicationActionModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  action,
  loading = false
}: PublicationActionModalProps) {
  const [reason, setReason] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (reason.trim()) {
      onConfirm(reason.trim())
      setReason('')
    }
  }

  const handleClose = () => {
    setReason('')
    onClose()
  }

  const suggestions = action === 'relevant' 
    ? [
        'Requer ação imediata do escritório',
        'Processo de interesse do cliente',
        'Prazo processual importante',
        'Intimação para manifestação',
        'Decisão judicial relevante'
      ]
    : [
        'Não se refere aos nossos clientes',
        'Processo de terceiros',
        'Comunicação administrativa',
        'Publicação duplicada',
        'Não requer ação do escritório'
      ]

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) handleClose() }}>
      <DialogContent size="md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <form id="publication-action-form" onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="publication-action-reason">Motivo da classificação:</Label>
            <Textarea
              id="publication-action-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="resize-none"
              rows={3}
              placeholder="Descreva o motivo para esta classificação..."
              required
            />
          </div>

          <div>
            <p className="mb-2 text-sm text-muted-foreground">Sugestões:</p>
            <div className="flex flex-wrap gap-2">
              {suggestions.map((suggestion) => (
                <Button
                  key={suggestion}
                  type="button"
                  variant="secondary"
                  size="xs"
                  onClick={() => setReason(suggestion)}
                  className="h-auto whitespace-normal rounded-full py-1 text-left"
                >
                  {suggestion}
                </Button>
              ))}
            </div>
          </div>
        </form>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={handleClose}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            form="publication-action-form"
            variant={action === 'relevant' ? 'default' : 'destructive'}
            disabled={loading || !reason.trim()}
          >
            {loading ? 'Processando...' : 'Confirmar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
